/**
 * This exception is thrown when a request is made with equipment serial that’s already in the database.
 */
export class DuplicateEquipmentSerialException extends Error {}

/**
 * Wrong serial on validatee
 */
export class InvalidSerialException extends Error {}

/**
 * Unable to connect to SAP
 */
export class UnableToConnectSAPException extends Error {}

/**
 * Invalid serial exceptions
 */
export class InvalidSerialNumberException extends Error {}
